export default () => ({
  pages: null,
  page: null,
  path: null
});
